import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import { pipeSystemCategories } from '../data/mock';
import useScrollAnimation from '../hooks/useScrollAnimation';

const PipeSystemSection = () => {
  const [ref, isVisible] = useScrollAnimation({ threshold: 0.1 });
  const [hoveredCategory, setHoveredCategory] = useState(null);

  const leftCardRef = useRef(null);   // محصول ویژه
  const rightCardRef = useRef(null);  // سیستم لوله کشی
  const hoverTimeout = useRef(null);

  // اسکریپت هم‌ارتفاعی
  useEffect(() => {
    const syncHeights = () => {
      if (!leftCardRef.current || !rightCardRef.current) return;

      const leftHeight = leftCardRef.current.offsetHeight;
      rightCardRef.current.style.minHeight = `${leftHeight}px`;
    };

    const r1 = requestAnimationFrame(syncHeights);
    window.addEventListener('resize', syncHeights);

    return () => {
      cancelAnimationFrame(r1);
      window.removeEventListener('resize', syncHeights);
    };
  }, []);

  const handleMouseEnter = (id) => {
    if (hoverTimeout.current) {
      clearTimeout(hoverTimeout.current);
    }
    setHoveredCategory(id);
  };

  const handleMouseLeave = () => {
    // کمی تأخیر تا منو ناگهانی بسته نشه
    hoverTimeout.current = setTimeout(() => {
      setHoveredCategory(null);
    }, 150);
  };

  return (
    <section
      ref={ref}
      className={`py-8 bg-gray-50 fade-in-up ${isVisible ? 'visible' : ''}`}
    >
      <div className="pp-container">
        <div className="grid md:grid-cols-2 gap-6 items-start">
          
          {/* Left Box - محصول ویژه */}
          <div
            ref={leftCardRef}
            className="bg-white rounded-xl shadow-sm border border-gray-200 p-5"
          >
            <h2 className="text-xl font-bold text-gray-900 mb-3 pb-2 border-b border-gray-200 text-center md:text-right">
              محصول ویژه
            </h2>

            <p className="text-gray-600 text-sm mb-4 leading-relaxed">
              پارس پایپینگ با کیفیت جهانی؛ مناسب پروژه‌های صنعتی، ساختمانی و تاسیساتی.
            </p>

            <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
              <div className="h-36 bg-white rounded-lg flex items-center justify-center border border-gray-200 overflow-hidden">
                <div className="relative w-full h-full flex items-center justify-center">
                  <div className="absolute w-24 h-24 rounded-full bg-gradient-to-br from-[#005bbb] to-[#0077dd] opacity-20 blur-xl" />

                  <div className="relative z-10 text-center">
                    <div className="w-20 h-20 mx-auto rounded-full border border-dashed border-gray-300 flex items-center justify-center">
                      <span className="text-xs text-gray-400">
                        جای تصویر محصول
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-3 text-center">
                <h3 className="font-bold text-gray-900">شیر صنعتی ویژه</h3>
                <p className="text-sm text-gray-600">کیفیت تضمین‌شده با قیمت رقابتی</p>
              </div>
            </div>
          </div>

          {/* Right Box - سیستم لوله کشی */}
          <div
            ref={rightCardRef}
            className="bg-white rounded-xl shadow-sm border border-gray-200 p-5"
          >
            <h2 className="text-xl font-bold text-gray-900 mb-3 pb-2 border-b border-gray-200 flex items-center justify-between">
              <span>سیستم لوله کشی</span>
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-1">
              {pipeSystemCategories.map((category) => (
                <div
                  key={category.id}
                  className="relative group"
                  onMouseEnter={() => handleMouseEnter(category.id)}
                  onMouseLeave={handleMouseLeave}
                >
                  <div className="flex items-center justify-between p-3 bg-gray-50 hover:bg-[#005bbb] hover:text-white rounded-lg cursor-pointer transition-all">
                    <span className="font-medium text-sm truncate">
                      {category.name}
                    </span>
                    <ChevronDown className="w-4 h-4 group-hover:rotate-180 transition-transform" />
                  </div>

                  {hoveredCategory === category.id && (
                    <div
                      className="absolute inset-x-0 top-full mt-2 bg-white border border-gray-200 rounded-lg shadow-lg z-20 p-3"
                      onMouseEnter={() => handleMouseEnter(category.id)}
                      onMouseLeave={handleMouseLeave}
                    >
                      {category.subcategories.map((sub, index) => (
                        <a
                          key={index}
                          href="#"
                          className="block text-sm text-gray-600 hover:text-[#005bbb] hover:bg-gray-50 px-2 py-1 rounded"
                        >
                          {sub}
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default PipeSystemSection;
